export default __webpack_public_path__ + "static/media/musicalIns.6bebec9e.svg";